export default {
    AllOrders: 0,
    Queue: 1,
    VendorQueue: 2,
    MyOrdersInProgress: 3,
    PendingAdminApproval: 4,
    NeedsAttention: 5,
    BillingFailed: 6,
    RushOrders: 7,
    MetalRoof: 8,
};
